import React from 'react'
import { UlupinarPageHeadProps } from './type'
import Image from '@/components/base/image/Image'
import { Column, Container, Row } from '@/components/base/gridview'
import { useApp } from '@/core/contexts/app'
import { path } from '@/core/utils'

const UlupinarPageHead: React.FC<UlupinarPageHeadProps> = ({
  title,
  thumbnail,
}) => {
  const app = useApp()

  return (
    <div className="UlupinarPageHead">
      {/* <Image  {...thumbnail} alt={title} /> */}
      <div
        className="thumbnail"
        style={{
          background: `url('${path.asset(app.environment, thumbnail.src)}')`,
        }}
      >
        <Container size="medium">
          <Row>
            <Column
              xs={{ size: 12 }}
              sm={{ size: 12 }}
              md={{ size: 12 }}
              lg={{ size: 12 }}
              xl={{ size: 12 }}
            >
              <div
                className="title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </Column>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default UlupinarPageHead
